import React from 'react'
import { Card } from 'primereact/card';
import { Icon } from '@iconify/react';

const AddCard = ({color, label, setVisible}) => {
    return (
        <Card
            title={label}
            header={<Icon icon="tabler:plus" style={{ color }} height={70} width={70} />}
            className="product-list-card"
            style={{
                color,
                border: `solid 2px ${color}`
            }}
            onClick={() => setVisible(true)}
        />
    )
}

export default AddCard
